export default "__VITE_ASSET__BMzTsMKP__"